"use client";

import { HouseValueTrend } from "@huub-web/shared";
import type { FC, Ref } from "react";
import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export type HouseValueTrendRecord = {
  title: string;
  value: number;
  percentage?: number;
};

export interface HouseValueTrendTemplateProps {
  title?: string;
  templates?: TemplateCollection;
}

/**
 * @deprecated
 */
export const HouseValueTrendTemplate: FC<
  HouseValueTrendTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ title, templates, ref, ...props }) => (
  <HouseValueTrend ref={ref} title={title} {...props}>
    {templates && <TemplatesParser templates={templates} level={1} />}
  </HouseValueTrend>
);
